<template>
  <div class="card border-0 text-center  modalMG" >
    <p class="fs-5 fw-bold poppins-semi-bold-mine-shaft-20px">Ha superado la cantidad 
      <br> de intentos
      permitidos 
       <br> para ingresar. </p> <p class="fs-5 fw-boldd ">Será dirigido a la opción de recuperación de contraseña</p> 
      <button @click="$router.push('/recuperarcontrasena')"
              class="boton-modal"
              style="background-color: #6f7fcc; border-color: #6f7fcc; ">
        Recuperar contraseña</button>


   </div>




</template>


<script>

export default {
  name: "ModalGeneral",
  components: {},
  
  props: [ 

  ],
  
};
</script>


<style>
    /* opacity: 0.71; */
.modalMG{
  padding: 2.5rem !important;
  background-color: #f5f6ff !important; 
  border-radius: 10px !important;
  border-color: transparent !important;
}
.fw-boldd{
  font-weight: 600 !important;
  color: var(--mine-shaft);
  font-family: var(--font-family-poppins);
  font-style: normal;
  line-height: 33px;
}

.modal-content {
    width: 90% !important;
    border-radius: 10px !important;
    border-color: transparent !important;
}
.p4{
  color: var(--white);
  font-family: var(--font-family-poppins);
  font-size: var(--font-size-m);
  font-weight: 600;
  letter-spacing: 0;
  line-height: 14px;
  min-height: 22px;
  text-align: center;
  width: 242px;
  padding: 7px 18px;
}
.custom-size-19-cantidad-de-intentos-superada-3-2 {
  align-items: flex-start;
  background-color: var(--blue-violet);
  display: flex;
  height: 660px;
  overflow: hidden;
  width: 1280px;
}

.overlap-group2-4 {
  height: 1182px;
  margin-left: -12px;
  margin-top: -199px;
  position: relative;
  width: 1292px;
}

.elipse-221-5 {
  border-radius: 591px;
  height: 1182px;
  left: 0;
  object-fit: cover;
  position: absolute;
  top: 0;
  width: 1182px;
}

.grupo-container-9 {
  height: 1061px;
  left: 152px;
  position: absolute;
  top: 6px;
  width: 1140px;
}

.grupo-9408-5 {
  height: 1059px;
  left: 3px;
  object-fit: cover;
  opacity: 0.23;
  position: absolute;
  top: 2px;
  width: 1112px;
}

.grupo-9407-5 {
  height: 1059px;
  left: 73px;
  object-fit: cover;
  opacity: 0.09;
  position: absolute;
  top: 2px;
  width: 1042px;
}

.grupo-9406-5 {
  height: 1027px;
  left: 0;
  object-fit: cover;
  position: absolute;
  top: 0;
  width: 1140px;
}

.rectngulo-1371-2 {
  width: 100%;
  background-color: var(--blue-violet) !important;
  border-radius: 10px !important;
  height: 50px;
}
.opciocv{
z-index:15;
}
.rectngulo-8acv {
  background-color: #867b7b;
  height: 1080px;
  left: 0;
  mix-blend-mode: multiply;
  opacity: 0.86;
  top: 0;
  width: 1920px;
}
.rectngulo-9xcv {
background-color: var(--black);
border: 1px solid;
border-radius: 0px 0px 39.87px 39.87px;
height: 378px;
left: 393px;
mix-blend-mode: multiply;
opacity: 0.56;
z-index: 5;
top: 51px;
width: 1118px;
}
.rectngulo-10acv {
background-color: var(--white);
border-radius: 0px 0px 39.87px 39.87px;
height: 409px;
left: 399px;
top: 51px;
z-index: 5;
width: 1104px;
}

.recuperar-contrasea5cv {
height: 67px;
left: 0;
letter-spacing: 0;
line-height: 40.8px;
text-align: center;
top: 4px;
width: 484px;
}

.boton-modal{
  width: 100%;
  background-color: var(--blue-violet) !important;
  border-radius: 10px !important;
  border-color: transparent !important;
  height: 50px;
}
.boton-modal:hover{
  background-color: var(--hover) !important;
}
.modal {
  background-color: #5460b559 !important;
  --bs-modal-padding: 2rem;
}
 .modal-body {
  padding: -5px !important;
}
 /* .modal-dialog {
  width: 410px !important;
} */
 .modal-contents {
  padding: 20px 20px 20px 20px !important;
  width: 360px;
  height: 318px;
  background-color: #5460B5 !important;
}
.boton-modal{
  width: 100%;
  margin-top: 32px;
  background-color: var(--blue-violet) !important;
  border-radius: 10px !important;
  height: 50px;
  color: var(--white);
  font-family: var(--font-family-poppins);
  font-size: var(--font-size-m);
  font-weight: 600;
  letter-spacing: 0;
  line-height: 14px;
  min-height: 22px;
  text-align: center;
}
</style>